// DocxPreview.tsx

import React, { useEffect, useRef, useState } from "react";
import { renderAsync } from "docx-preview";

interface DocxPreviewProps {
  file: Blob;
}

const DocxPreview: React.FC<DocxPreviewProps> = ({ file }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const renderDocx = async () => {
      if (!containerRef.current) return;
      containerRef.current.innerHTML = "";

      const buffer = await file.arrayBuffer();
      await renderAsync(buffer, containerRef.current);
    };

    renderDocx();
  }, [file]);

  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.1, 1.7));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.1, 0.5));
  const handleResetZoom = () => setZoom(1);

  return (
    <div className="h-full flex flex-col pb-12">
      {/* Zoom Controls */}
      <div className="flex justify-end items-center space-x-2 px-4 py-2 border-b border-gray-200">
        <button
          type="button"
          onClick={handleZoomOut}
          className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300 text-sm"
        >
          -
        </button>
        <span className="text-sm text-gray-700">{Math.round(zoom * 100)}%</span>
        <button
          type="button"
          onClick={handleZoomIn}
          className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300 text-sm"
        >
          +
        </button>
        <button
          type="button"
          onClick={handleResetZoom}
          className="text-sm py-1 px-3 rounded bg-blue-600 text-white hover:bg-blue-500 transition"
        >
          Reset
        </button>
      </div>

      {/* Scaled Preview Container */}
      <div className="flex-1 overflow-auto p-4">
        <div
          ref={containerRef}
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: "top left",
            width: `${100 / zoom}%`,
          }}
        />
      </div>
    </div>
  );
};

export default DocxPreview;
